import { RadioGroup, type RadioGroupProps } from '@chakra-ui/react';

export type UiRadioGroupProps = RadioGroupProps;

export const UiRadioGroup = RadioGroup;
